import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getGenericBulkUpsertState = createSelector(
  fromReducers.getGenericBulkUpsertFeatureState,
  (state: fromReducers.GenericBulkUpsertFeatureState) => state.genericBulkUpsert
);

export const getValidating = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.validating);

export const getUploading = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.uploading);

export const getValidationResponse = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.validationResponse);

export const getUploadResponse = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.uploadResponse);

export const getSelectedFile = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.selectedFile);

export const getError = createSelector(getGenericBulkUpsertState, (state: fromReducers.GenericBulkUpsertState) => state.error);